
const colorConfigs = {
  btn: {
    cancel: {
      bg: "#FFFFFF",
      color: "#005CA6",
      border: "1px solid #005CA6",
    },
    main: {
      bg: "#005CA6",
      tailwind: "bg-[#005CA6]"
    },
    delete: {
      bg: "#D92D20"
    }
  },
  color: {
    main: "#005CA6"
  },
  sidebar: {
    bg: "#ffffff",
    tailwindBg: "bg-white",
    color: "#58707b",
    hoverBg: "#eeeeee",
    activeBg: "rgba(105, 178, 232, 0.10)"
  },
  topbar: {
    bg: "#005CA6",
    color: "#FFFFFF"
  },
  jumper: {
    bg: "#005CA6",
  },
  mainBg: "#ffffff",
  primaryColor: "#005CA6",
};

export default colorConfigs;